import i18next from "i18next";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Downloads() {
  const { t } = useTranslation();
  // const userAgent = navigator.userAgent || window.opera;

  // if (/android/i.test(userAgent)) {
  //   return (window.location.href =
  //     "https://play.google.com/store/apps/details?id=la.lcampki.client");
  // }

  // if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
  //   return (window.location.href =
  //     "https://apps.apple.com/ao/app/lao-softkey/id6445804009");
  // }

  return (
    <div className="h-full flex-1">
      <Helmet>
        <title>{t("download")} | Trusted Pay</title>
      </Helmet>
      <div className="mt-[80px]">
        <div className="flex flex-col items-center gap-[10px] bg-[#EFF0FF] py-[50px] px-4">
          <h1 className="text-center sm600:text-5xl text-[64px] font-[700] capitalize not-italic leading-[70px] tracking-[-0.5px] text-[#565ADD]">
            {t("download")}
          </h1>
          <div className="flex flex-col items-start self-stretch pb-5">
            <div className="mx-auto my-0 flex w-[16%] items-start self-stretch py-0">
              <span className="w-full self-stretch border-t-[5px] border-solid border-[#565ADD]"></span>
            </div>
          </div>
          <div className="flex flex-col items-center self-stretch">
            <p className="py-0 text-center font-semibold">
              {i18next.language === "vi" ? (
                <>
                  {t("labelDownload")}{" "}
                  <span className="text-[#565ADD] hover:underline">
                    Trusted Pay
                  </span>
                </>
              ) : (
                <>
                  <span className="text-[#565ADD] hover:underline">
                    Trusted Pay
                  </span>{" "}
                  {t("labelDownload")}
                </>
              )}
            </p>
          </div>
        </div>
      </div>
      <div className="mx-auto grid max-w-4xl gap-4 p-4 md:my-8 md:grid-cols-2 md:gap-8">
        <Link
          to={"https://apps.apple.com/us/app/trusted-pay/id6749049528"}
          target="_blank"
        >
          <div className="flex h-20 items-center gap-4 rounded-lg bg-[#565ADD] p-4 text-2xl text-white shadow-md">
            <svg
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              className="h-8 w-8"
            >
              <path
                fill="currentColor"
                d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
              ></path>
            </svg>
            <span>IOS</span>
          </div>
        </Link>
        <Link
          to={
            "https://play.google.com/store/apps/details?id=vn.mobileid.trustedpay.client"
          }
          target="_blank"
        >
          <div className="flex h-20 items-center gap-4 rounded-lg bg-[#565ADD] p-4 text-2xl text-white shadow-md">
            <svg
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              className="h-8 w-8"
            >
              <path
                fill="currentColor"
                d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
              ></path>
            </svg>
            <span>Android</span>
          </div>
        </Link>
      </div>
    </div>
  );
}
